import { render } from "./ProjectProcureEndDateOffcanvas.vue?vue&type=template&id=623ac05f&scoped=true&ts=true"
import script from "./ProjectProcureEndDateOffcanvas.ts?vue&type=script&lang=ts"
export * from "./ProjectProcureEndDateOffcanvas.ts?vue&type=script&lang=ts"

import "./ProjectProcureEndDateOffcanvas.scss?vue&type=style&index=0&id=623ac05f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623ac05f"]])

export default __exports__